module.exports = __webpack_public_path__ + "static/img/4.2a9864c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/eng/4.png
// module id = hkcr
// module chunks = 0